module.exports = __webpack_public_path__ + "static/img/highVacuumImg.f948cf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/highVacuumImg.png
// module id = aGKE
// module chunks = 1